// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  ReviewerGroup,
  ReviewerGroupFromJSON,
  ReviewerGroupToJSON,
  ReviewerGroupPayload,
  ReviewerGroupPayloadFromJSON,
  ReviewerGroupPayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface CreateReviewerGroupRequest {
  reviewerGroupPayload: ReviewerGroupPayload;
}

export interface DeleteReviewerGroupRequest {
  id: number;
  project: number;
}

export interface GetReviewerGroupRequest {
  id: number;
  project: number;
}

export interface GetReviewerGroupsRequest {
  project: number;
  start?: number;
  limit?: number;
}

export interface UpdateReviewerGroupRequest {
  reviewerGroupPayload: ReviewerGroupPayload;
  id: number;
}

/**
 * no description
 */
export class ReviewerGroupsApi extends runtime.BaseAPI {
  /**
   * Create a saved reviewer group. Requires the existing project settings administrator access and enabled review. Every member must be an active project user with review permission.
   * Create a reviewer group
   */
  async createReviewerGroupRaw(
    requestParameters: CreateReviewerGroupRequest
  ): Promise<runtime.ApiResponse<ReviewerGroup>> {
    if (
      requestParameters.reviewerGroupPayload === null ||
      requestParameters.reviewerGroupPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "reviewerGroupPayload",
        "Required parameter requestParameters.reviewerGroupPayload was null or undefined when calling createReviewerGroup."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/reviewergroups`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ReviewerGroupPayloadToJSON(requestParameters.reviewerGroupPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReviewerGroupFromJSON(jsonValue)
    );
  }

  /**
   * Create a saved reviewer group. Requires the existing project settings administrator access and enabled review. Every member must be an active project user with review permission.
   * Create a reviewer group
   */
  async createReviewerGroup(
    requestParameters: CreateReviewerGroupRequest
  ): Promise<ReviewerGroup> {
    const response = await this.createReviewerGroupRaw(requestParameters);
    return await response.value();
  }

  /**
   * Mark a group as deleted while retaining it for review history. Requires the existing project settings administrator access and enabled review. Refuses deletion while the group is the project default or has pending reviews with no assigned reviewer; clear the default or reassign those reviews first. A review already started by a named user keeps its assignment.
   * Delete a reviewer group
   */
  async deleteReviewerGroupRaw(
    requestParameters: DeleteReviewerGroupRequest
  ): Promise<runtime.ApiResponse<ReviewerGroup>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteReviewerGroup."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteReviewerGroup."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/reviewergroups/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReviewerGroupFromJSON(jsonValue)
    );
  }

  /**
   * Mark a group as deleted while retaining it for review history. Requires the existing project settings administrator access and enabled review. Refuses deletion while the group is the project default or has pending reviews with no assigned reviewer; clear the default or reassign those reviews first. A review already started by a named user keeps its assignment.
   * Delete a reviewer group
   */
  async deleteReviewerGroup(
    requestParameters: DeleteReviewerGroupRequest
  ): Promise<ReviewerGroup> {
    const response = await this.deleteReviewerGroupRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get a group in the specified project. Deleted groups remain readable for historical review display and cannot be selected for new work.
   * Get a reviewer group
   */
  async getReviewerGroupRaw(
    requestParameters: GetReviewerGroupRequest
  ): Promise<runtime.ApiResponse<ReviewerGroup>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getReviewerGroup."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getReviewerGroup."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/reviewergroups/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReviewerGroupFromJSON(jsonValue)
    );
  }

  /**
   * Get a group in the specified project. Deleted groups remain readable for historical review display and cannot be selected for new work.
   * Get a reviewer group
   */
  async getReviewerGroup(
    requestParameters: GetReviewerGroupRequest
  ): Promise<ReviewerGroup> {
    const response = await this.getReviewerGroupRaw(requestParameters);
    return await response.value();
  }

  /**
   * List active reviewer groups in a project. Requires project access. Works while review or review groups are turned off, so settings can show saved group names before the toggles are saved. Member IDs are returned without granting review permission.
   * List reviewer groups
   */
  async getReviewerGroupsRaw(
    requestParameters: GetReviewerGroupsRequest
  ): Promise<runtime.ApiResponse<Array<ReviewerGroup>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getReviewerGroups."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/reviewergroups`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ReviewerGroupFromJSON)
    );
  }

  /**
   * List active reviewer groups in a project. Requires project access. Works while review or review groups are turned off, so settings can show saved group names before the toggles are saved. Member IDs are returned without granting review permission.
   * List reviewer groups
   */
  async getReviewerGroups(
    requestParameters: GetReviewerGroupsRequest
  ): Promise<Array<ReviewerGroup>> {
    const response = await this.getReviewerGroupsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Replace an active group's name and members. Requires the existing project settings administrator access and enabled review. Existing named reviewer assignments and completed review history are preserved.
   * Edit a reviewer group
   */
  async updateReviewerGroupRaw(
    requestParameters: UpdateReviewerGroupRequest
  ): Promise<runtime.ApiResponse<ReviewerGroup>> {
    if (
      requestParameters.reviewerGroupPayload === null ||
      requestParameters.reviewerGroupPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "reviewerGroupPayload",
        "Required parameter requestParameters.reviewerGroupPayload was null or undefined when calling updateReviewerGroup."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateReviewerGroup."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/reviewergroups/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ReviewerGroupPayloadToJSON(requestParameters.reviewerGroupPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReviewerGroupFromJSON(jsonValue)
    );
  }

  /**
   * Replace an active group's name and members. Requires the existing project settings administrator access and enabled review. Existing named reviewer assignments and completed review history are preserved.
   * Edit a reviewer group
   */
  async updateReviewerGroup(
    requestParameters: UpdateReviewerGroupRequest
  ): Promise<ReviewerGroup> {
    const response = await this.updateReviewerGroupRaw(requestParameters);
    return await response.value();
  }
}
